import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';

export const getSuperAgentBadge = (userTrustLevelNumber?: number | null, userTrustLevelName?: string | null) => {
  if (!userTrustLevelNumber || !userTrustLevelName) {
    return null;
  }

  return <SuperAgentLevelViewContainer levelNumber={userTrustLevelNumber} levelName={userTrustLevelName} />;
};
